import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer'
import StatusView from '../components/StatusView'
import { getSiteConfig } from '../constantFunction'
import '../style.css'

/** 站内 404 与「站点不存在 / 未开放」（Post 页拿到 404 时带 state.missing 跳来） */
function Empty() {
    const location = useLocation()
    const missing = Boolean(location.state && location.state.missing)

    useEffect(() => {
        const site = getSiteConfig()
        document.title = missing ? '站点不存在' : '页面不存在' + (site && site.title ? ' · ' + site.title : '')
    }, [missing])

    return (
        <div className='status-page'>
            <Nav siteMissing={missing} />
            <main className='status-page-main'>
                {missing
                    ? <StatusView kind='siteMissing' actions={[{ label: '查看所有站点', href: '/', primary: true }]} />
                    : <StatusView kind='pageMissing' actions={[
                        { label: '回到首页', to: '/', primary: true },
                        { label: '浏览全部笔记', to: '/notes/' },
                    ]} />}
            </main>
            {!missing && <Footer />}
        </div>
    )
}

export default Empty;
